import { useClerk } from "@clerk/react";
import { useState } from "react";

import { isElectron } from "../../env";
import { resolveClerkSignInProps } from "./authRedirect";
import { DeskEmailCodeSignInDialog } from "./DeskEmailCodeSignIn";

// The Desk opens its own email-code form (DeskEmailCodeSignIn.tsx, #1711); the browser keeps Clerk's sign-in. When
// Clerk needs a step that form can't do, the Desk opens Clerk's sign-in with the email prefilled.
export function useCleoConnectAuthPrompt() {
  const clerk = useClerk();
  const [deskPromptOpen, setDeskPromptOpen] = useState(false);
  const openAuthPrompt = () => {
    if (isElectron) {
      setDeskPromptOpen(true);
      return;
    }
    clerk.openSignIn(resolveClerkSignInProps(window.location.href, isElectron));
  };
  const authPrompt = isElectron ? (
    <DeskEmailCodeSignInDialog
      open={deskPromptOpen}
      onOpenChange={setDeskPromptOpen}
      onUseFullSignIn={(emailAddress) =>
        clerk.openSignIn({
          ...resolveClerkSignInProps(window.location.href, isElectron),
          initialValues: { emailAddress },
        })
      }
    />
  ) : null;
  return { authPrompt, openAuthPrompt };
}
